import React from "react";
import "./Application.css";
import Google_store from "../../assests/Googleplay.png";
import App_store from "../../assests/Appstore.png";
import Iphones from "../../assests/iPhone.png";

const Application = () => {
  return (
    <section className="app-section">
      <div className="app-inner">
        <div className="app-text">
          <span className="app-label">Mobile App</span>
          <h2 className="app-title">
            Your bank. Your pocket.<br />
            <span className="app-accent">Always with you.</span>
          </h2>
          <p className="app-desc">
            Download the Sendcheap app and get instant access to transfers,
            bill payments, crypto and more — online or offline, 24/7.
          </p>
          <div className="app-stores">
            <a
              href="https://apps.apple.com/ng/app/sendcheap/id6448403237"
              target="_blank"
              rel="noreferrer"
            >
              <img src={App_store} alt="App Store" className="app-store-btn" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.sendcheap.sendcheap&hl=en"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Google_store} alt="Google Play" className="app-store-btn" />
            </a>
          </div>
          <div className="app-trust-row">
            <span>&#9733;&#9733;&#9733;&#9733;&#9733;</span>
            <span>4.8 rating · 50K+ downloads</span>
          </div>
        </div>

        <div className="app-visual">
          <div className="app-phone-glow"></div>
          <img src={Iphones} alt="Sendcheap App" className="app-phones" />
        </div>
      </div>
    </section>
  );
};

export default Application;
